// extracted by mini-css-extract-plugin
module.exports = {"page":"Printable_page__2mhmC"};